import ToolBox from '../ToolBox';
import Template from "ui/Template";
import {i18n} from "ui/i18n";
import ColorsSetModel, {EVENT_CHANGE_COLOR, EVENT_DISABLE_OPACITY} from "ui/canvas/models/ColorsSetModel";
import Color from "ui/helpers/Color";
import colorsSetView from './colors-set.handlebars';

/**
 * Current Colors Set toolbox
 */
class ColorsSet extends ToolBox {
	/**
	 * Class constructor
	 *
	 * @param {Object} [options]
	 */
	constructor(options = {}) {
		super(Object.assign({
			title: i18n('title.colors-set')
		}, options));

		/**
		 * @type {ColorsSetModel}
		 * @private
		 */
		this._colorsSet = options.colorsSet || new ColorsSetModel();

		this.setBodyElement(
			new Template(colorsSetView)
				.createElement({})
		);

		this._els = {
			opacity: this.body.querySelector('.editor-colors-set__opacity'),
			opacitySlots: this.body.querySelectorAll('.editor-colors-set__opacity-slot'),
			opacityColors: this.body.querySelectorAll('.editor-colors-set__opacity-slot > .editor-colors-set__opacity-color > div'),
		};

		this._colorsSet.addListener(EVENT_CHANGE_COLOR, this.updateSlots.bind(this));
		this._colorsSet.addListener(EVENT_DISABLE_OPACITY, this.updateSlots.bind(this));

		this._els.opacitySlots.forEach((el) => {
			el.addEventListener('click', () => {
				this._colorsSet.switchOpacitySlot(parseInt(el.getAttribute('data-index')));
			})
		});

		this.updateSlots();
	}

	/**
	 * Updates slots elements
	 *
	 * @returns {void}
	 */
	updateSlots() {
		let els;

		els = this._els.opacityColors;
		let color = Color.create(this._colorsSet.getCurrentColor()),
			alpha = [255, 255 * 0.8, 255 * 0.6, 255 * 0.4, 255 * 0.2],
			currentOpacitySlot = this._colorsSet.getCurrentOpacitySlot();

		for (let i = 0; i < els.length; i++) {
			this._els.opacitySlots[i].classList.toggle('editor-colors-set__opacity-slot_selected', i === currentOpacitySlot);
			els[i].style.backgroundColor = color.setAlpha(alpha[i]).rgbaCss;
		}
	}
}

export default ColorsSet;
